import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import Layout from "./components/Layout.jsx";
import { AuthProvider } from "./context/AuthContext.jsx";
import CategoryPage from "./pages/CategoryPage.jsx";
import GoogleOnboardingPage from "./pages/GoogleOnboardingPage.jsx";
import Home from "./pages/Home.jsx";
import LeaderboardPage from "./pages/LeaderboardPage.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import ProfilePage from "./pages/ProfilePage.jsx";
import QuizPlayer from "./pages/QuizPlayer.jsx";
import RegisterPage from "./pages/RegisterPage.jsx";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Wraps QuizPlayer with a key derived from the slug so React fully remounts
// the component (resetting all state) when navigating between quizzes.
const QuizPlayerKeyed = () => {
  const { slug } = useParams();
  return <QuizPlayer key={slug} />;
};

const App = () => {
  return (
    <HelmetProvider>
    <BrowserRouter basename="/v2">
      <AuthProvider>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="category/:category" element={<CategoryPage />} />
            <Route path="quiz/:slug" element={<QuizPlayerKeyed />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="register/google" element={<GoogleOnboardingPage />} />
            <Route path="leaderboard" element={<LeaderboardPage />} />
            <Route path="profile" element={<ProfilePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
